module.exports = __webpack_public_path__ + "img/bg6.96a34c41.jpg";